<template>
  <div class="cheetah-sidebar-wrapper" :data-mini="sidebarMini">
    <template v-if="Object.keys(website).length">
    <nav class="cheetah-sidebar-wrapper__navbar navbar d-block d-md-none navbar-expand-lg navbar-light bg-light"
         :class="{'show' : sidebarMobile}">
      <div class="navbar__header">
        <h5 class="navbar__header--title"><i class="svg-icon svgi-website"></i><span>{{ website.title }}</span></h5>
        <button class="btn navbar__header--btn-close btn-close p-2" @click="$emit('toggleSidebarMobile')">×</button>
      </div>

      <ul class="navbar-nav ml-auto">
        <!-- My Pages -->
        <li class="nav-item">
          <router-link class="nav-link" :class="{'active' : active === 'site-pages'}"
                       data-ba-i="my-pages-cheetah"
                       :to="{ name: 'SitePages', params : { id : website.encrypted_id , data: website } }">
            <i class="svg-icon svgi-list"></i>
            <span>{{ $t('ct-my-pages')}}</span>
          </router-link>
        </li>

        <!-- Overview -->
        <li class="nav-item">
          <router-link class="nav-link" :class="{'active' : active === 'overview'}"
                       data-ba-i="website-overview"
                       :to="{ name: 'Analytics', params : { id : website.encrypted_id , data: website } }">
            <i class="svg-icon svgi-report"></i>
            <span>{{ $t('ct-website-overview') }}</span>
          </router-link>
        </li>

        <!-- Website Settings -->
        <li class="nav-item">
          <router-link class="nav-link" :class="{'active' : active === 'site-settings'}"
                       data-ba-i="website-settings"
                       :to="{ name: 'GeneralSettings', params : { id : website.encrypted_id , data: website } }"
          ><i class="svg-icon svgi-settings-site"></i>
            <span>{{ $t('ct-website-settings') }}</span>
          </router-link>
        </li>

        <!-- Website Scripts -->
        <li class="nav-item">
          <router-link class="nav-link" :class="{'active' : active === 'script-settings'}"
                       :to="{ name: 'GeneralSettings', params : { id : website.encrypted_id , data: website } }">
            <i class="svg-icon svgi-settings-script"/>
            <span>{{ $t('ct-script-settings') }}</span>
          </router-link>
        </li>

        <!-- Website SEO -->
        <li class="nav-item">
          <router-link
            class="nav-link" :class="{'active' : active === 's-e-o-settings'}"
            :to="{ name: 'GeneralSettings', params : { id : website.encrypted_id , data: website } }"
          >
            <i class="svg-icon svgi-settings-seo"/>
            <span>{{ $t('ct-seo-settings') }}</span>
          </router-link>
        </li>



        <!-- Website Items -->
        <li class="nav-item">
          <a class="nav-link dropdown-caret collapsed" :class="{'active' : active === 'items'}"
             data-toggle="collapse" href="#collapseItemsMobile" role="button" aria-controls="collapseItemsMobile"
             aria-expanded="true">
            <i class="svg-icon svgi-elements"></i>
            <span>{{ $t('ct-items-all-edit') }}</span>
          </a>
          <div class="collapsed collapse show" id="collapseItemsMobile"
               :class="['items', 'items-popups', 'items-headers', 'items-footers'].includes(active) ? 'show' : ''">
            <div class="submenu">
              <!-- Popups -->
              <router-link
                v-if="(website && website.layouts && website.layouts[0])"
                :to="{ name: 'Items', params: { id: website.encrypted_id, layout_id: website.layouts[0].encrypted_id, type_item: 'popups' }}"
                class="nav-link"
                :class="{'active' : active === 'items-popups'}"
              >
                <i class="svg-icon svgi-popup"></i>
                <span>{{$t('ct-popups')}}</span>
              </router-link>

              <!-- Headers -->
              <router-link
                v-if="(website && website.layouts && website.layouts[0])"
                :to="{ name: 'Items', params: { id: website.encrypted_id, layout_id: website.layouts[0].encrypted_id, type_item: 'headers' }}"
                class="nav-link"
                :class="{'active' : active === 'items-headers'}"
              >
                <i class="svg-icon svgi-header"></i>
                <span>{{$t('ct-headers')}}</span>
              </router-link>

              <!-- Footers -->
              <router-link
                v-if="(website && website.layouts && website.layouts[0])"
                :to="{ name: 'Items', params: { id: website.encrypted_id, layout_id: website.layouts[0].encrypted_id, type_item: 'footers' }}"
                class="nav-link"
                :class="{'active' : active === 'items-footers'}"
              >
                <i class="svg-icon svgi-footer"></i>
                <span>{{$t('ct-footers')}}</span>
              </router-link>
            </div>
          </div>
        </li>

        <!-- GDPR -->
        <li class="nav-item">
          <router-link
            class="nav-link"
            :class="{'active' : active === 'g-d-p-r-settings'}"
            :to="{ name: 'GDPRSettings', params : { id : website.encrypted_id , data: website } }"
          >
            <i class="svg-icon svgi-security"></i>
            <span>{{ $t('ct-gdpr-settings') }}</span>
          </router-link>
        </li>

        <!-- Members -->
        <li class="nav-item">
          <a class="nav-link  dropdown dropdown-caret collapsed" data-toggle="collapse"
             href="#collapseMembersMobile" role="button"
             aria-expanded="true"
             aria-controls="collapseMembersMobile" v-if="showMembersArea">
            <i class="svg-icon svgi-people"></i>
            <span>{{$t('ct-members-area') }}</span>
          </a>
          <div class="collapse" id="collapseMembersMobile"
               :class="active === 'site-members' || active === 'form-members' || active === 'emails' ? 'show' : ''">
            <div class="submenu">
              <!-- Members List -->
              <router-link
                class="nav-link"
                :class="{'active' : active === 'site-members'}"
                :to="{ name: 'SiteMembers', params : { website_id : website.encrypted_id , data: website  } }"
              >
                <i class="svg-icon svgi-peoples"></i>
                <span>{{ $t('ct-members') }}</span>
              </router-link>

              <!-- Form Configs -->
              <router-link
                class="nav-link"
                :class="{'active' : active === 'form-members'}"
                :to="{ name: 'FormMembers', params : { website_id : website.encrypted_id , data: website  } }"
              >
                <i class="svg-icon svgi-form"></i>
                <span>{{ $t('ct-members-form') }}</span>
              </router-link>

              <!-- Automatic e-mails -->
              <router-link
                class="nav-link"
                :class="{'active' : active === 'emails'}"
                :to="{ name: 'Emails', params : { website_id : website.encrypted_id , data: website  } }">
                <i class="svg-icon svgi-email-timer"></i>
                <span>{{ $t('ct-automatic-emails') }}</span>
              </router-link>

              <!-- Integrations -->
              <router-link
                v-if="website && website.restrict_areas ? website.restrict_areas.filter(restrict => restrict.type_id === 3).length : false"
                class="nav-link"
                :class="{'active' : active === 'integrations'}"
                :to="{ name: 'MembersIntegrations', params : { website_id : website.encrypted_id , data: website  } }"
              >
                <i class="svg-icon svgi-money"></i>
                <span>{{ $t('ct-integrations') }}</span>
              </router-link>
            </div>
          </div>
        </li>

        <!-- Superchekout -->
        <li class="nav-item">
          <a :class="{ 'disabled-link': tokenCheckout === false}"
             href="#"
             class="nav-link"
             @click.prevent="openSupercheckout()">
            <i class="svg-icon svgi-checkout"></i>
            <span>{{ $t('ct-supercheckout')}}</span>
          </a>
        </li>

        <!-- Blog -->
        <li class="nav-item">
          <a
            href="#"
            class="nav-link"
            @click.prevent="openBlog()">
            <i class="svg-icon svgi-blog"></i>
            <span>{{ $t('ct-blog') }}</span>
          </a>
        </li>

        <!-- Browser notification -->
        <li class="nav-item">
          <a class="nav-link dropdown-caret collapsed" data-toggle="collapse"
             href="#collapseBrowserMobile" role="button"
             :aria-expanded="true"
             aria-controls="collapseBrowser">
            <i class="svg-icon svgi-browser"></i>
            <span>{{ $t('ct-browser-option') }}</span>
          </a>

          <div class="collapse" id="collapseBrowserMobile">
            <div class="submenu">
              <template v-if="(isBrowserNotif)">
                <a href="#" class="nav-link"
                   @click.prevent="$refs['browser-bn-enable'].open()">
                  <i class="svg-icon svgi-browser"></i>
                  <span>{{ $t('ct-browser-settings')}}</span>
                </a>

                <a href="#" class="nav-link" @click.prevent="openBrowser()">
                  <i class="svg-icon svgi-browser"></i>
                  <span>{{ $t('ct-browser-open')}}</span>
                </a>

                <a href="#" class="nav-link" @click.prevent="browserRemove()">
                  <i class="svg-icon svgi-browser"></i>
                  <span>{{ $t('ct-browser-remove')}}</span>
                </a>
              </template>

              <a  v-if="!isBrowserNotif" href="#" class="nav-link" @click.prevent="browser()">
                <i class="svg-icon svgi-browser"></i>
                <span>{{ $t('ct-browser')}}</span>
              </a>
            </div>
          </div>
        </li>

        <!-- Social Proof -->
        <li class="nav-item">
          <a
            href="#"
            class="nav-link"
            @click.prevent="openSocialProof()">
            <i class="svg-icon svgi-social-proof"></i>
            <span>{{ $t('ct-social-proof')}}</span>
          </a>
        </li>

        <!-- Booking -->
        <li class="nav-item">
          <a
            href="#"
            class="nav-link"
            @click.prevent="openBooking()">
            <i class="svg-icon svgi-booking"></i>
            <span>{{ $t('ct-booking') }}</span>
          </a>
        </li>

          <!-- Domain -->
          <li class="nav-item">
            <router-link
              :to="{
                name: 'Domain',
                params: {
                  id: website ? website.encrypted_id : websiteObj.encrypted_id,
                },
              }"
            class="nav-link"
            >
            <i class="svg-icon svgi-http"></i>
              <span>{{ $t("ct-domain") }}</span>
            </router-link>
        </li>

        <!-- Transfer -->
        <li class="nav-item">
          <a href="#" class="nav-link" @click="transfer(true, website)">
            <i class="svg-icon svgi-transfer"></i>
            <span>{{ $t('ct-transfer')}}</span>
          </a>
        </li>

        <!-- Go to sitemap -->
        <li class="nav-item">
          <a
            href="#"
            class="nav-link"
            @click.prevent="goToSitemap(website)">
            <i class="svg-icon svgi-sitemap"></i>
            <span>{{ $t('ct-go-to-sitemap') }}</span>
          </a>
        </li>

        <!-- Go to Website -->
        <li class="nav-item">
          <a
            href="#"
            class="nav-link"
            @click.prevent="goToWebsite(website)">
            <i class="svg-icon svgi-open-external"></i>
            <span>{{ $t('ct-go-to-website')}}</span>
          </a>
        </li>

        <!-- Dashboard -->
        <li class="nav-item">
          <router-link
            :to="{ name: 'Dashboard' }"
            class="nav-link">
            <i class="svg-icon svgi-home-back"></i>
            <span>{{ $t('ct-back-home')}}</span>
          </router-link>
        </li>

      </ul>
    </nav>

    <ul
      class="cheetah-sidebar-wrapper__list-group list-group list-group-flush text-left"
      v-if="(website && website.encrypted_id)"
    >
      <li>
        <a href="#" @click.prevent=""
          class="list-group-item list-group-item-action list-group-item--title"
        ><i class="svg-icon svgi-website"></i><span>{{ website.title }}</span></a>

        <hr class="m-0">

        <router-link class="list-group-item list-group-item-action" :class="{'active' : active === 'site-pages'}"
                     data-ba-i="my-pages-cheetah"
          :to="{ name: 'SitePages', params : { id : website.encrypted_id , data: website } }">
          <i v-tooltip.right="{ content:$t('ct-my-pages'), class: 'tooltip-custom'}" class="svg-icon svgi-list"></i>
          <span>{{ $t('ct-my-pages')}}</span>
        </router-link>

        <router-link class="list-group-item list-group-item-action" :class="{'active' : active === 'overview'}"
                     data-ba-i="website-overview"
          :to="{ name: 'Analytics', params : { id : website.encrypted_id , data: website } }">
          <i v-tooltip.right="{ content:$t('ct-website-overview'), class: 'tooltip-custom'}" class="svg-icon svgi-report"></i>
          <span>{{ $t('ct-website-overview') }}</span>
        </router-link>

        <router-link
          class="list-group-item list-group-item-action"
          :class="{'active' : active === 'site-settings'}"
          data-ba-i="website-settings"
          :to="{ name: 'GeneralSettings', params : { id : website.encrypted_id , data: website } }"
        ><i v-tooltip.right="{ content:$t('ct-website-settings'), class: 'tooltip-custom'}" class="svg-icon svgi-settings-site"></i>
          <span>{{ $t('ct-website-settings') }}</span>
        </router-link>

        <router-link
          class="list-group-item list-group-item-action"
          :class="{'active' : active === 'script-settings'}"
          data-ba-i="website-scripts"
          :to="{ name: 'ScriptSettings', params : { id : website.encrypted_id , data: website } }"
        >
          <i
            v-tooltip.right="{ content:$t('ct-script-settings'), class: 'tooltip-custom'}" class="svg-icon svgi-settings-script" style="background-repeat : no-repeat"/>
          <span>{{ $t('ct-script-settings') }}</span>
        </router-link>

        <router-link
          class="list-group-item list-group-item-action" :class="{'active' : active === 's-e-o-settings'}"
          data-ba-i="website-seo"
          :to="{ name: 'GeneralSettings', params : { id : website.encrypted_id , data: website } }"
        >
          <i v-tooltip.right="{ content:$t('ct-seo-settings'), class: 'tooltip-custom'}" class="svg-icon svgi-settings-seo"/>
          <span>{{ $t('ct-seo-settings') }}</span>
        </router-link>

        <!-- erick pedir pra ja carregar com o menu elementos globais aberto. pra voltar, adicionar classe colapsed no <a> e remover o segundo 'show' do ternario -->
        <a class="list-group-item list-group-item-action dropdown-caret collapsed" :class="{'active' : active === 'items'}"
           data-toggle="collapse" href="#collapseItems" role="button" aria-controls="collapseItems"
           :aria-expanded="active === 'items' ? true : false"
           v-tooltip.right="{ content:$t('ct-items-all-edit-info'), class: 'tooltip-custom'}">
          <i class="svg-icon svgi-elements"></i>
          <span>{{ $t('ct-items-all-edit') }}</span>
        </a>
        <div class="collapsed collapse show" id="collapseItems"
             :class="['items', 'items-popups', 'items-headers', 'items-footers'].includes(active) ? 'show' : ''">
          <div class="submenu">
            <router-link
              v-if="(website && website.layouts && website.layouts[0])"
              :to="{ name: 'Items', params: { id: website.encrypted_id, layout_id: website.layouts[0].encrypted_id, type_item: 'popups' }}"
              :website="website"
              data-ba-i="my-popups"
              class="list-group-item list-group-item-action"
              :class="{'active' : active === 'items-popups'}"
            >
              <i v-tooltip.right="{ content:$t('ct-popups'), class: 'tooltip-custom'}" class="svg-icon svgi-popup"></i>
              <span>{{$t('ct-popups')}}</span>
            </router-link>

            <router-link
              v-if="(website && website.layouts && website.layouts[0])"
              :to="{ name: 'Items', params: { id: website.encrypted_id, layout_id: website.layouts[0].encrypted_id, type_item: 'headers' }}"
              :website="website"
              data-ba-i="my-headers"
              class="list-group-item list-group-item-action"
              :class="{'active' : active === 'items-headers'}"
            >
              <i v-tooltip.right="{ content:$t('ct-headers'), class: 'tooltip-custom'}" class="svg-icon svgi-header"></i>
              <span>{{$t('ct-headers')}}</span>
            </router-link>

            <router-link
              v-if="(website && website.layouts && website.layouts[0])"
              :to="{ name: 'Items', params: { id: website.encrypted_id, layout_id: website.layouts[0].encrypted_id, type_item: 'footers' }}"
              :website="website"
              data-ba-i="my-footers"
              class="list-group-item list-group-item-action"
              :class="{'active' : active === 'items-footers'}"
            >
              <i v-tooltip.right="{ content:$t('ct-footers'), class: 'tooltip-custom'}" class="svg-icon svgi-footer"></i>
              <span>{{$t('ct-footers')}}</span>
            </router-link>
          </div>
        </div>

        <router-link
          class="list-group-item list-group-item-action"
          :class="{'active' : active === 'g-d-p-r-settings'}"
          data-ba-i="gdpr-settings"
          :to="{ name: 'GDPRSettings', params : { id : website.encrypted_id , data: website } }"
        >
          <i v-tooltip.right="{ content:$t('ct-gdpr-settings'), class: 'tooltip-custom'}" class="svg-icon svgi-security"></i>
          <span>{{ $t('ct-gdpr-settings') }}</span>
        </router-link>

        <hr>

        <a class="list-group-item list-group-item-action dropdown-caret collapsed" data-toggle="collapse"
           href="#collapseMembers" role="button"
           aria-expanded="true"
           aria-controls="collapseMembers" v-if="showMembersArea">
          <i v-tooltip.right="{ content:$t('ct-members-area'), class: 'tooltip-custom'}" class="svg-icon svgi-people"></i>
          <span>{{$t('ct-members-area') }}</span>
        </a>
        <div class="collapse" id="collapseMembers"
             :class="active === 'site-members' || active === 'form-members' || active === 'emails' ? 'show' : ''">
          <div class="submenu">
            <router-link
              class="list-group-item list-group-item-action"
              :class="{'active' : active === 'site-members'}"
              data-ba-i="members-area-site-members"
              :to="{ name: 'SiteMembers', params : { website_id : website.encrypted_id , data: website  } }"
            >
              <i v-tooltip.right="{ content:$t('ct-members'), class: 'tooltip-custom'}" class="svg-icon svgi-peoples"></i>
              <span>{{ $t('ct-members') }}</span>
            </router-link>

            <router-link
              class="list-group-item list-group-item-action"
              :class="{'active' : active === 'form-members'}"
              data-ba-i="members-area-form-members"
              :to="{ name: 'FormMembers', params : { website_id : website.encrypted_id , data: website  } }"
            >
              <i v-tooltip.right="{ content:$t('ct-members-form'), class: 'tooltip-custom'}" class="svg-icon svgi-form"></i>
              <span>{{ $t('ct-members-form') }}</span>
            </router-link>

            <router-link
              class="list-group-item list-group-item-action"
              :class="{'active' : active === 'emails'}"
              data-ba-i="members-area-automatic-emails"
              :to="{ name: 'Emails', params : { website_id : website.encrypted_id , data: website  } }">
              <i v-tooltip.right="{ content:$t('ct-automatic-emails'), class: 'tooltip-custom'}" class="svg-icon svgi-email-timer"></i>
              <span>{{ $t('ct-automatic-emails') }}</span>
            </router-link>

            <router-link
              v-if="website && website.restrict_areas ? website.restrict_areas.filter(restrict => restrict.type_id === 3).length : false"
              class="list-group-item list-group-item-action"
              data-ba-i="members-area-integrations"
              :class="{'active' : active === 'integrations'}"
              :to="{ name: 'MembersIntegrations', params : { website_id : website.encrypted_id , data: website  } }"
            >
              <i v-tooltip.right="{ content:$t('ct-integrations'), class: 'tooltip-custom'}" class="svg-icon svgi-money"></i>
              <span>{{ $t('ct-integrations') }}</span>
            </router-link>
          </div>
        </div>

        <a :class="{ 'disabled-link': tokenCheckout === false, 'flex-column': sidebarMini }"
           href="#"
           data-ba-i="super-checkout"
           class="list-group-item list-group-item-action"
           @click.prevent="openSupercheckout()">
          <i v-tooltip.right="{ content:$t('ct-supercheckout'), class: 'tooltip-custom'}" class="svg-icon svgi-checkout"></i>
          <small class="text-danger d-none" :class="{'d-block': sidebarMini && tokenCheckout === false}" style="width: 60px;text-align: center;overflow-wrap: anywhere;padding: 3px 5px 0;">{{ this.errorToken }}</small>
          <div class="d-block">
            <span>{{ $t('ct-supercheckout')}}</span>
            <small class="text-danger d-none" :class="{'d-block': !sidebarMini && tokenCheckout === false}" style="margin-left:20px;margin-top:5px">{{ this.errorToken }}</small>
          </div>
        </a>

        <a
          href="#"
          class="list-group-item list-group-item-action"
          data-ba-i="blog"
          @click.prevent="openBlog()">
          <i v-tooltip.right="{ content:$t('ct-blog'), class: 'tooltip-custom'}" class="svg-icon svgi-blog"></i>
          <span>{{ $t('ct-blog') }}</span>
        </a>

        <a class="list-group-item list-group-item-action dropdown-caret collapsed" data-toggle="collapse"
           href="#collapseBrowser" role="button"
           :aria-expanded="true"
           v-tooltip.right="{ content:$t('ct-browser-info'), class: 'tooltip-custom'}"
           aria-controls="collapseBrowser">
          <i class="svg-icon svgi-browser"></i>
          <span>{{ $t('ct-browser-option') }}</span>
        </a>

        <div class="collapse" id="collapseBrowser">
          <div class="submenu">
            <template v-if="(isBrowserNotif)">
              <a href="#" class="list-group-item list-group-item-action"
                 data-ba-i="browser-notification-settings"
                 @click.prevent="$refs['browser-bn-enable'].open()">
                <i v-tooltip.right="{ content:$t('ct-browser-settings'), class: 'tooltip-custom'}"
                   class="svg-icon svgi-browser"></i>
                <span>{{ $t('ct-browser-settings')}}</span>
              </a>

              <a href="#" class="list-group-item list-group-item-action" @click.prevent="openBrowser()"
                 data-ba-i="browser-notification-settings">
                <i v-tooltip.right="{ content:$t('ct-browser-open'), class: 'tooltip-custom'}"
                   class="svg-icon svgi-browser"></i>
                <span>{{ $t('ct-browser-open')}}</span>
              </a>

              <a href="#" class="list-group-item list-group-item-action" @click.prevent="browserRemove()">
                <i v-tooltip.right="{ content:$t('ct-browser-remove'), class: 'tooltip-custom'}"
                   class="svg-icon svgi-browser"></i>
                <span>{{ $t('ct-browser-remove')}}</span>
              </a>
            </template>

            <a  v-if="!isBrowserNotif" href="#" class="list-group-item list-group-item-action" @click.prevent="browser()">
              <i v-tooltip.right="{ content:$t('ct-browser'), class: 'tooltip-custom'}"
                 class="svg-icon svgi-browser"></i>
              <span>{{ $t('ct-browser')}}</span>
            </a>
          </div>
        </div>

        <a
          href="#"
          class="list-group-item list-group-item-action"
          data-ba-i="social-proof"
          @click.prevent="openSocialProof()">
          <i v-tooltip.right="{ content:$t('ct-social-proof'), class: 'tooltip-custom'}" class="svg-icon svgi-social-proof"></i>
          <span>{{ $t('ct-social-proof')}}</span>
        </a>

        <!-- <a
          href="#"
          class="list-group-item list-group-item-action"
          @click.prevent="openHeatMap()">
          <i v-tooltip.right="{ content:$t('ct-heat-map'), class: 'tooltip-custom'}" class="svg-icon svgi-heat-map"></i>
          <span>{{ $t('ct-heat-map')}}</span>
        </a> -->

        <a
          href="#"
          class="list-group-item list-group-item-action"
          data-ba-i="booking"
          @click.prevent="openBooking()">
          <i v-tooltip.right="{ content:$t('ct-booking'), class: 'tooltip-custom'}" class="svg-icon svgi-booking"></i>
          <span>{{ $t('ct-booking') }}</span>
        </a>

        <hr>

          <router-link
          class="list-group-item list-group-item-action"
            :class="{ active: active === 'domain' }"
            data-ba-i="domain"
            :to="{
              name: 'Domain',
              params: {
                id: website ? website.encrypted_id : websiteObj.encrypted_id,
              },
            }"
          >
            <i
              v-tooltip.right="{
                content: $t('ct-domain'),
                class: 'tooltip-custom',
              }"
              class="svg-icon svgi-http"
            />
            <span>{{ $t("ct-domain") }}</span>
          </router-link>

        <a
          href="#"
          class="list-group-item list-group-item-action"
            data-ba-i="transfer-website"
            @click.prevent="transfer(true, website)"
          >
            <i
              v-tooltip.right="{
                content: $t('ct-transfer'),
                class: 'tooltip-custom',
              }"
              class="svg-icon svgi-transfer"
            ></i>
            <span>{{ $t("ct-transfer") }}</span>
        </a>

        <router-link
          class="list-group-item list-group-item-action"
          :class="{'active' : active === 'split-test'}"
          data-ba-i="split-test"
          :to="{ name: 'SplitTest', params : { id : website ? website.encrypted_id : websiteObj.encrypted_id,  data: website ? website: websiteObj  } }"
        >
          <i
            v-tooltip.right="{ content:$t('ct-info-split-test'), class: 'tooltip-custom'}"
            class="svg-icon svgi-split-test"
          />
          <span>{{ $t('ct-split-test') }}</span>
        </router-link>

        <router-link
          v-if="website && website.layouts && website.layouts[0]"
          :to="{
                  name: 'Items',
                  params: {
                    id: website.encrypted_id,
                    layout_id: website.layouts[0].encrypted_id,
                    type_item: 'multiaction',
                  },
                }"
          :website="website"
          data-ba-i="my-multiaction"
          class="list-group-item list-group-item-action"
          :class="{ active: active === 'items-multiaction' }"
        >
          <i
            v-tooltip.right="{
                    content: $t('ct-multiaction'),
                    class: 'tooltip-custom',
                  }"
            class="svg-icon svgi-multiple-actions"
          ></i>
          <span>{{ $t("ct-multiaction") }}</span>
        </router-link>

        <router-link
          class="list-group-item list-group-item-action"
          :class="{'active' : active === 'VoteSystem'}"
          data-ba-i="gdpr-settings"
          :to="{ name: 'VoteSystem', params : { id : website.encrypted_id , data: website } }"
        >
          <i v-tooltip.right="{ content:$t('ct-gdpr-settings'), class: 'tooltip-custom'}" class="svg-icon svgi-vote"></i>
          <span>{{ $t('ct-vote-settings') }}</span>
        </router-link>

        <router-link
          class="list-group-item list-group-item-action"
          :class="{'active' : active === 'restore-pages'}"
          data-ba-i="restore-pages"
          :to="{ name: 'SiteRestorePages', params : { id : website.encrypted_id , data: website } }"
        >
          <i v-tooltip.right="{ content:$t('ct-restore-pages'), class: 'tooltip-custom'}" class="svg-icon svgi-lixeira"></i>
          <span>{{ $t('ct-restore-pages') }}</span>
        </router-link>

        <hr>

        <a
          href="#"
          class="list-group-item list-group-item-action"
          data-ba-i="go-to-sitemap"
          @click.prevent="goToSitemap(website)"
        >
          <i v-tooltip.right="{ content:$t('ct-go-to-sitemap'), class: 'tooltip-custom'}" class="svg-icon svgi-sitemap"></i>
          <span>{{ $t('ct-go-to-sitemap') }}</span>
        </a>

        <a
          href="#"
          data-ba-i="go-to-site"
          class="list-group-item list-group-item-action"
          @click.prevent="goToWebsite(website)"
        >
          <i v-tooltip.right="{ content:$t('ct-go-to-website'), class: 'tooltip-custom'}" class="svg-icon svgi-open-external"></i>
          <span>{{ $t('ct-go-to-website')}}</span>
        </a>

        <router-link
          :to="{ name: 'Dashboard' }"
          class="list-group-item list-group-item-action"
        >
          <i v-tooltip.right="{ content:$t('ct-back-home'), class: 'tooltip-custom'}" class="svg-icon svgi-home-back"></i>
          <span>{{ $t('ct-back-home')}}</span>
        </router-link>
      </li>
    </ul>

    <site-transfer-component
      :site="modal.transfer.config"
      :show="modal.transfer.show"
      @transfer="transfer"
    ></site-transfer-component>

    <site-domain-component
      :site="website"
      :show="modal.domain.show"
      :title="modal.domain.title"
      :type="modal.domain.type"
      @setDomain="setDominio"
      @cancel="cancelModal('domain')"
    ></site-domain-component>

    <sweet-modal ref="browser-bn-enable" width="40%" class="sweet-modal-theme-cheetah" :title="$t('ct-browser-title')" hide-close-button blocking>
      <slot name="content">
        <p>{{$t('ct-browser-enable-desc')}}</p>
        <div class="form-group form-check">
          <div class="custom-control custom-switch form-group w-100">
            <input type="checkbox" class="custom-control-input" id="bn-enable-site" v-model="browser_notification.open_site_load">
            <label class="custom-control-label" for="bn-enable-site">{{$t('ct-browser-enable-open-site')}}</label>
          </div>
          <small>{{$t('ct-browser-enable-open-site-desc')}}</small>
        </div>
      </slot>
      <button slot="button" class="btn btn-outline-light mt-2" @click.prevent="$refs['browser-bn-enable'].close()">{{ $t('ct-cancel') }}</button>
      <button slot="button" class="btn btn-success mt-2" @click.prevent="saveBrowserSettingsConfig(null, true)" ><i class="svg-icon svgi-save svgi-light"></i>{{ $t('ct-confirm') }}</button>
    </sweet-modal>

    <modal-delete-component
      :show="modalDelete.browser.show"
      :text="modalDelete.browser.text"
      :description="modalDelete.browser.description"
      :values="modalDelete.browser.config"
      @cancel="cancelModalBrowser('browser')"
      @exclude="removeBrowserSettings"
    ></modal-delete-component>

    <social-proof-component ref="social-proof" :website_id="idWebsite || website.encrypted_id"></social-proof-component>

    <heat-map-component ref="heat-map" :website="website" :website_id="idWebsite || website.encrypted_id"></heat-map-component>
    </template>
    <template v-else>
      <ul
        class="cheetah-sidebar-wrapper__list-group list-group list-group-flush text-left"
      >
        <li>
          <a href="#" @click.prevent=""
             class="list-group-item list-group-item-action list-group-item--title"
          >
            <div class="ct-skeleton ct-skeleton-avatar ct-skeleton-animate-wave mr-2" style="width: 40px; height: 30px"></div>
            <div class="ct-skeleton ct-skeleton-text ct-skeleton-animate-wave w-100 mb-0"></div>
          </a>

          <hr class="m-0">

          <a href="#" @click.prevent="" class="list-group-item list-group-item-action" :key="index" v-for="index in 15">
            <div class="ct-skeleton ct-skeleton-avatar ct-skeleton-animate-wave mr-2" style="width: 30px; height: 25px"></div>
            <div class="ct-skeleton ct-skeleton-text ct-skeleton-animate-wave w-100 mb-0"></div>
          </a>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
//  import of methods getter and setter of website-config
import {getWebsiteConfig, setWebsiteConfig} from '../../../../js/services/editor/configManager';

import {get as getWebsite} from './../../../../js/services/editor/website';
import {apiUrl, auth as supercheckoutAuth} from '../../../../js/services/integrations-internas/supercheckout';
import {createBrowserNotif as browserNotif} from '../../../../js/services/integrations-internas/browserNotification';
import SiteTransferComponent from './SiteTransfer';
import SiteDomainComponent from './SiteDomain';
import SocialProofComponent from './SocialProof';
import HeatMapComponent from './HeatMap';
import ModalDeleteComponent from './../../components/ModalDelete';

import {SweetModal} from 'sweet-modal-vue';

import {
  updateVersion
} from '../../../../js/services/editor/publish';

import {mapGetters} from 'vuex';
import axios from 'axios';

export default {
  name: 'SiteSidebar',
  props: ['idWebsite', 'website', 'sidebarMini', 'sidebarMobile'],
  components: {
    SiteTransferComponent,
    SiteDomainComponent,
    SweetModal,
    ModalDeleteComponent,
    SocialProofComponent,
    HeatMapComponent
  },
  data() {
    return {
      active: '',
      betaTester: false,
      tokenCheckout: false,
      errorToken: null,
      websiteObj: {},
      user_editor: {},
      modal: {
        domain: {
          show: false,
          title: '',
          type: ''
        },
        transfer: {
          show: false,
          config: ''
        }
      },
      browser_notification: {
        user_email: '',
        user_password: '',
        site_id: '',
        site_name: '',
        project_id: '',
        embed_code: '',
        sw_file: '',
        enabled: false,
        open_site_load: true
      },
      bn_settings: null,
      isBrowserNotif: false,
      modalDelete: {
        browser: {
          text: this.$t('ct-confirm-delete-browser'), // 'Do you really want to delete this campaign?',
          // description: 'Deletara as variaveis do browser notification no arquivo website-config',
          show: false,
          config: ''
        },

        restrict: {show: false, config: ''}
      }

    };
  },

  watch: {

    'getUser.user_editor': function(value) {
      this.user_editor = value;
    },

    'isBrowserNotif': function() {
      this.getBrowserSettings();
    },

    $route: function(route) {
      if (route.name) this.setActiveRouteName(route.name, route.params);
    },

    'website.encrypted_id': function(website) {
      this.getSuperCheckoutAuth();
    }
  },

  methods: {
    ...mapGetters({getUser: 'user', getUserToken: 'token', getOfficeToken: 'getOfficeToken'}),
    openSupercheckout() {
      supercheckoutAuth(this.website.id, this.website.language).then(async({data}) => {
          if (data.token) {
            let token = data.token;
            localStorage.setItem('token_supercheckout', token);
            this.tokenCheckout = token;

            return window.open(`${apiUrl()}?token=${this.tokenCheckout}`);
          } else {
            this.errorToken = error;
          }
        });
    },
    getBlogUrl() { 
      const baseURLs = {
          'local':'http://blog.localhost',
          'io'   :'https://blog.kub.app.builderall.io',
          'info' :'https://blog.kub.app.builderall.info',
          'com'  : 'https://blog.builderall.com'
      }

      let url = ''

      if(window.location.host.includes('localhost:')) {
        url = baseURLs.local
      } else {
        url = baseURLs[
          window.location.host.includes('.com') ? 'com' : (
            window.location.host.includes('.info') ? 'info' : 'io'
          )
        ]
      }

      return `${url}/logincheetah-login?token=J0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9`
    },
    openBlog() {
      let url = this.getBlogUrl();
      url = url + '&website_id=' + this.website.encrypted_id;
      window.open(url, '_blank');
    },

    openBooking() {
      let token = localStorage.getItem('token') || false;

      if (token && this.getUser() && parseInt(this.getUser().id_office_user)) {
        const officeDomain = typeof process.env.OFFICE_URL !== 'undefined' ? process.env.OFFICE_URL : 'https://office.builderall.com';

        let urlWeb = `${officeDomain}/us/office/booking`;

        const form = document.createElement('form');
        form.method = 'GET';
        form.action = urlWeb;
        form.target = '_blank';
        form.id = 'form-booking';

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }
    },

    openSocialProof() {
      this.$refs['social-proof'].open();
    },

    openHeatMap(){
      this.$refs['heat-map'].open();
    },

    checkBlogAceess() {
      if (this.website && typeof this.website.encrypted_id !== 'undefined') {
        let vm = this;
        vm.betaTester = true;
        let url = this.getBlogUrl();
        url = url + '&website_id=' + this.website.encrypted_id;
        axios.get(url + '&checkIsBeta=true')
          .then(({data}) => {
            if (data.beta_tester) {
              vm.betaTester = true;
            }
          });
      }
    },

    getSuperCheckoutAuth() {
      if (this.website && typeof this.website.encrypted_id !== 'undefined') {
        var error = this.$t('ct-checkout-erro-retrieving-token');
        supercheckoutAuth(this.website.id, this.website.language).then(async({data}) => {
          if (data.token) {
            let token = data.token;
            localStorage.setItem('token_supercheckout', token);
            this.tokenCheckout = token;
          } else {
            this.errorToken = error;
          }
        });
      }
    },
    goToSitemap(config) {
     if (config.status !== 'active')
        return;

      window.open('https://' + `${config.access_url}/sitemap.xml`, '_blank');
    },
    goToWebsite(config) {
      if (config.status !== 'active')
        return;

      window.open('https://' + config.access_url, '_blank');
    },

    /* Browser Notification */
    //  create campaign on browser notification API
    browser() {
      if (this.bn_settings !== null) {
        this.saveBrowserSettings(null, true);
      } else {
        browserNotif({
          website: {
            id: this.website.encrypted_id,
            title: this.website.title
          }
        }).then(data => {
          try {
            if (data['data']['result']) {
              this.saveBrowserSettings(data, true);
            } else { //  project browser created yet but desabled
              if (
                typeof this.bn_settings['enabled'] !== 'undefined' &&
                  !this.bn_settings['enabled']
              ) {
                this.saveBrowserSettings(null, true);
              } else {
                this.$snotify.error(this.$t('ct-browser-error'), {
                  position: 'centerTop'
                });
              }
            }
          } catch (e) {
            console.log('erro no retorno da API');
          }
        })
          .catch((error) => console.log('error browser link', error))
          .finally(() => console.log(''));
      }
    },

    browserRemove() {
      if (this.isBrowserNotif) //  true - If project already exists, change enabled to false on: website-config.browserSettings
      { this.confirmDelete('browser', {}) }
    },

    /* Browser Notification */
    //  create campaign on browser notification API
    openBrowser() {
      var site_id = this.website.id;
      if (
        this.bn_settings !== null &&
          typeof this.bn_settings['project_id'] !== 'undefined' &&
          this.bn_settings !== 0 &&
          (typeof this.bn_settings['enabled'] === 'undefined' || this.bn_settings['enabled'])
      ) {
        var project_id = this.bn_settings['project_id'];

        var language = (navigator.language || navigator.userLanguage);
        var bn_url = process.env.BROWSER_NOTIFICATIONS_URL || 'https://notify.builderall.com';
        bn_url += '/login.php';

        var data = {
          push_pid: project_id,
          lang: language.substr(0, 2),
          token: this.getOfficeToken()
        };

        if (this.browser_notification.user_email) {
          data = {
            ...data,
            user_email: 'cheetah_ba_' + site_id + '@cheetah_ba.com',
          };
        }

        var method = 'GET';
        this.postAndRedirect(bn_url, data, method);
      } else {
        this.$snotify.error(this.$t('ct-browser-not-exist'), {
          position: 'centerTop'
        });
      }
    },

    /* Transfer website */
    transfer(show, config = '') {
      this.modal.transfer = {
        show: show,
        config: config
      };
    },

    disconnectDomain() {
      this.modal.domain.show = true;
      this.modal.domain.type = 'disconnect';
      this.modal.domain.title = this.$t('ct-domain-info');
    },

    connectDomain() {
      this.modal.domain.show = true;
      this.modal.domain.type = 'connect';
      this.modal.domain.title = this.$t('ct-domain-connect');
    },

    setDominio: function(params) {
      this.website.dominio = params.domain;
      this.disconnectDomain();

    },

    cancelModal(type) {
      if (this.$refs[type]) {
        this.$refs[type].close();
        return;
      }
      this.modal[type].show = false;
      this.modal[type].config = '';
    },

    // get browser website-configurations
    getBrowserSettings() {
      getWebsiteConfig(this.$route.params.id).then(data => {
        if (typeof data.data.browserSettings !== 'undefined') {
          this.bn_settings = JSON.parse(data.data.browserSettings.value);
          if (
            this.bn_settings !== null &&
              typeof this.bn_settings['project_id'] !== 'undefined' &&
              this.bn_settings !== 0 &&
              (typeof this.bn_settings['enabled'] === 'undefined' || this.bn_settings['enabled'])
          ) {
            if (typeof this.bn_settings['userEmail'] !== 'undefined') {
              this.browser_notification.user_email = this.bn_settings['userEmail'];
              this.browser_notification.user_password = this.bn_settings['userPassword'];
              this.browser_notification.site_id = this.bn_settings['siteId'];
              this.browser_notification.site_name = this.bn_settings['siteName'];
            }

            this.browser_notification.project_id = this.bn_settings['project_id'];
            this.browser_notification.embed_code = this.bn_settings['embed_code'];
            this.browser_notification.sw_file = this.bn_settings['sw_file'];
            this.browser_notification.enabled = this.bn_settings['enabled'];
            this.isBrowserNotif = this.browser_notification.enabled;

            if (typeof this.bn_settings['open_site_load'] !== 'undefined') {
              this.browser_notification.open_site_load = this.bn_settings['open_site_load'];
            }
          }
        } else {
        }
      });
    },

    // save browser website-configurations
    saveBrowserSettings(result, enabled) {
      let obj = null;
      if (result !== null) { //  create project with success
        obj = {
          website_id: this.$route.params.id,
          key: 'browserSettings',
          value: JSON.stringify({
            'project_id': result['data']['project_id'],
            'embed_code': result['data']['embed_code'],
            'sw_file': result['data']['sw_file'],
            'enabled': enabled
          })
        };

        if (enabled) {
          this.$refs['browser-bn-enable'].open();
        }
      } else { //  re-enable project wich already exists or disable project when confirm delete
        obj = {
          website_id: this.$route.params.id,
          key: 'browserSettings',
          value: JSON.stringify({
            ...this.bn_settings,
            ...{
              'enabled': enabled,
              'open_site_load': this.browser_notification.open_site_load
            }
          })
        };

        if (enabled) {
          this.getBrowserSettings();
          this.$refs['browser-bn-enable'].open();
        }
      }

      setWebsiteConfig(obj).then((data) => {
        this.isBrowserNotif = enabled;
        this.getBrowserSettings();
        this.republishAction();
      })
        .catch((error) => console.log('error save website-config', error));
    },

    saveBrowserSettingsConfig() {
      let obj = {
        website_id: this.$route.params.id,
        key: 'browserSettings',
        value: JSON.stringify({
          'project_id': this.bn_settings['project_id'],
          'embed_code': this.bn_settings['embed_code'],
          'sw_file': this.bn_settings['sw_file'],
          'enabled': true,
          'open_site_load': this.browser_notification.open_site_load
        })
      };

      setWebsiteConfig(obj)
        .then((data) => {
          this.isBrowserNotif = true;
          this.getBrowserSettings();
          this.republishAction(false);
          this.$refs['browser-bn-enable'].close();

          this.$snotify.success(this.$t('ct-success-true'), {
            position: 'centerTop'
          });
        })
        .catch((error) => console.log('error save website-config', error));
    },

    republishAction(showAlert = true) {
      updateVersion(this.$parent.website.encrypted_id)
        .then(res => {
          console.log(res.data);
        });

      if (showAlert) {
        this.$snotify.success(this.$t('ct-republished'), {
          position: 'centerTop'
        });
      }
    },

    removeBrowserSettings() {
      this.cancelModalBrowser('browser');
      this.saveBrowserSettings(null, false);
      this.isBrowserNotif = !this.isBrowserNotif;
      this.getBrowserSettings();
    },

    cancelModalBrowser(type) {
      this.modalDelete[type].show = false;
      this.modalDelete[type].config = '';
    },

    confirmDelete(type, config) {
      this.modalDelete[type].text = this.$t(`ct-confirm-delete-${type}`);
      this.modalDelete[type].show = true;
      this.modalDelete[type].config = config;
    },

    postAndRedirect(url, postData, method) {
      if (method === undefined) {
        method = 'POST';
      }
      var blank = '_blank';
      var postFormStr = "<form method='" + method + "' action='" + url + "' target='" + blank + "'>\n";
      for (var key in postData) {
        if (postData.hasOwnProperty(key)) {
          if (postData[key] !== undefined && postData[key] !== null) {
            if (postData[key] instanceof Array) { // => If is array, loop through
              postData[key].forEach(function(entry) {
                postFormStr += "<input type='hidden' name='" + key + "[]' value='" + entry + "' />";
              });
            } else {
              postFormStr += "<input type='hidden' name='" + key + "' value='" + postData[key] + "' />";
            }
          }
        }
      }
      postFormStr += '</form>';
      var formElement = $(postFormStr);
      $('body').append(formElement);
      $(formElement).submit();
    },

    sendRequestWithPost(url, postData) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      var data = JSON.stringify(postData);
      xhr.send(data);
    },

    setActiveRouteName(routeName, params) {
      if (typeof params.type_item !== 'undefined' && params.type_item.length) {
        routeName = `${routeName}-${params.type_item}`;
      }

      this.active = routeName.replace(/(?:^|\.?)([A-Z])/g, function(x, y) {
        return '-' + y.toLowerCase();
      }).replace(/^-/, '');
    }

  },

  created() {
    this.getSuperCheckoutAuth();
    if (this.$route.name) this.setActiveRouteName(this.$route.name, this.$route.params);
  },

  mounted() {
    let vm = this;

    vm.getBrowserSettings();
    setTimeout(() => {
      vm.getSuperCheckoutAuth();
    }, 2000);
    vm.$forceUpdate();
  },
  computed: {
    showMembersArea() {
      if (typeof this.website !== 'undefined' && typeof this.website.restrict_areas !== 'undefined') return this.website.restrict_areas.length > 0;
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SiteSidebar.vue